import React, {Component} from 'react';
import {Helmet} from 'react-helmet';

// Components
import LinkBtn from '../components/LinkBtn';
import Footer from '../components/Footer';
import Modal from '../components/Modal';
import Navbar from '../components/Navbar';

class NotFound extends Component{

    state = {
        showModal: "none",
        displayMobile: "none"
      }
    
    toggleModal = () => {
    if (this.state.showModal === "none") {
        this.setState({
            showModal: "block"
        })
        window.scrollTo(0,0);
    }
    else {
        this.setState({
            showModal: "none"
        })
    }
    }

    toggleMobileMenu = () => {
        if (this.state.displayMobile === "none") {
            this.setState({
              displayMobile: "flex"
            })
        }
        else {
            this.setState({
              displayMobile: "none"
            })
        }
      }

    render() {
        return(
            <div className="NotFound">
            <Helmet>
                <title>404 | Candid Goat: Tech Solutions for Small Businesses</title>
                <meta name="description" content="This not the page you're looking for (*Jedi Wave*)." />
                <meta name="robots" content="noindex" /> 
            </Helmet>
            <Modal showModal={this.state.showModal} click={this.toggleModal} />
            <Navbar click={this.toggleModal} displayMobile={this.state.displayMobile} mobileMenu={this.toggleMobileMenu} />
            <div className="notFoundHero navbarNeighbor flexColumn flexStart">
                <h1 className="heroFont bold centerText">404: Not Found</h1>
                <h2 className="subTitleFont centerText">Looks like you're a long way from home.<br/>Here's a shortcut back.</h2>
                <LinkBtn click="/" name="Return Home" classes="subTitleFont bold"/>
            </div>
            <Footer />
            </div>
        )
    }
}

export default NotFound;


// WEBPACK FOOTER //
// ./src/pages/NotFound.js